import { Description } from "@mui/icons-material";
import FormSection from "controls/global/form-section";
import {
  ActionType,
  useSideNavProvider,
} from "pages/file/SideNavProvider";
import React, {
  useEffect,
  useRef,
} from "react";
import { useFormState } from "react-hook-form";
import GradientIcon from "theme/icons/GradientIcon";
import FileData from "./FileData";
import { useFiles } from "utils/context/FilesContext";

type Props = {
  onNavigate: (url: string) => void;
  isExistingFile?: boolean;
};

function FileSection({ onNavigate, isExistingFile = false }: Props) {
  const { errors, touchedFields } = useFormState();
  const { sideNavState, sideNavAction } = useSideNavProvider();
  const fileRef = useRef<HTMLElement>();
  const [{ isReadOnly ,isReadOnlyMode }]  = useFiles();

  const hasError = () =>
    (errors.fileNameNumber && touchedFields.fileNameNumber && !isReadOnly) ||
    (errors.agency !== undefined && errors.agency?.message) ||
    (errors.agencyLocation !== undefined &&
      touchedFields.agencyLocation !== undefined);

  useEffect(() => {
    if (sideNavState.items.get("File")?.childRef?.current) return;
    sideNavAction({
      type: ActionType.UPDATE,
      item: { name: "File", childRef: fileRef },
    });
  }, [sideNavState, fileRef]);

  return (
    <FormSection
      navItemRef={fileRef}
      data-test="fileSection"
      icon={<GradientIcon Icon={Description} />}
      isError={hasError()}
      title={"File" + (isReadOnlyMode ? " - Read Only" : "")}
    >
      <FileData onNavigate={onNavigate} isExistingFile={isExistingFile} />
    </FormSection>
  );
}

export default FileSection;
